/**
 * @desc Building maintenance layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import layers from "./layers";

export default {
  modules: {
    layers
  },
  state: {
    name: "buildingmaintenance",
    deptTitle: "Building Maintenance",
    icon: "home"
  }
};
